import { render } from "./HiVaultImage.vue?vue&type=template&id=ae3338e2"
import script from "./HiVaultImage.vue?vue&type=script&lang=js"
export * from "./HiVaultImage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__